import { DocumentNode, gql } from '@apollo/client';
import * as React from 'react';

import { EModItemResolutionState } from '@/client/legacy-shared-modules/moderation-item/moderationType';
import { PostRemovedCard } from '@/components/postPages/PostPage/components/PostRemovedCard';

import { Moderation_PostFragment } from './graphql-types/Moderation_PostFragment';

const POST_FRAGMENT = gql`
  fragment Moderation_PostFragment on PostV2 {
    _id
    moderationItem {
      _id
      resolutionState
    }
  }
`;

export const Moderation: React.FC<{ post: Moderation_PostFragment }> & {
  postFragment: DocumentNode;
} = (props) => {
  const { post } = props;
  if (!post.moderationItem) {
    return null;
  }
  return post.moderationItem.resolutionState ===
    EModItemResolutionState.PENDING ||
    post.moderationItem.resolutionState === EModItemResolutionState.REJECTED ? (
    <PostRemovedCard />
  ) : null;
};
Moderation.postFragment = POST_FRAGMENT;
